/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import type { Provider } from "@ethersproject/providers";
import type { ISendPayment, ISendPaymentInterface } from "../ISendPayment";

const _abi = [
  {
    inputs: [],
    name: "getPrice",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "ticket",
        type: "bytes32",
      },
    ],
    name: "pay",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
] as const;

export class ISendPayment__factory {
  static readonly abi = _abi;
  static createInterface(): ISendPaymentInterface {
    return new utils.Interface(_abi) as ISendPaymentInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider,
  ): ISendPayment {
    return new Contract(address, _abi, signerOrProvider) as ISendPayment;
  }
}
